import React, { useEffect, useState } from 'react'
import { FloatingInspectorButton, FloatingInspectorButtonProps, MainText } from '../FloatingInspectorButton'
import { useTranslation } from 'react-i18next'
import FloatingInspectorCircleRenderer from '../SharedComponents/FloatingInspectorCircleRenderer'
import FloatingInspectorButtonImageInCircle from './FloatingInspectorButtonImageInCircle'

export interface ImageInCircleAndTextProps
  extends Pick<
    FloatingInspectorButtonProps,
    'onClick' | 'selected' | 'disabled' | 'tooltipText' | 'placementTooltip' | 'marginTooltip'
  > {
  text: string
  src: string
  showText?: boolean
}

// Enforce that only one of src or backgroundColor can be provided
type OnlySrc = { src: string; backgroundColor?: never }
type OnlyBackgroundColor = { backgroundColor: string; src?: never }
export type StrictImageInCircleAndTextProps = (OnlySrc | OnlyBackgroundColor) &
  Pick<FloatingInspectorButtonProps, 'onClick' | 'selected' | 'disabled'> & {
    text: string
  }

const FloatingInspectorButtonImageInCircleAndText: React.FC<ImageInCircleAndTextProps> = ({
  src,
  text,
  onClick,
  selected,
  disabled,
  tooltipText,
  placementTooltip,
  marginTooltip,
  showText,
}) => {
  const [t] = useTranslation()
  const tooltipTextOnHideText = tooltipText || (!showText && text ? t(text) : undefined)

  if (!showText) {
    return (
      <FloatingInspectorButtonImageInCircle
        src={src}
        onClick={onClick}
        selected={selected}
        disabled={disabled}
        tooltipText={tooltipTextOnHideText}
        placementTooltip={placementTooltip}
        marginTooltip={marginTooltip}
      />
    )
  }

  return (
    <FloatingInspectorButton
      onClick={onClick}
      selected={selected}
      disabled={disabled}
      tooltipText={tooltipText}
      placementTooltip={placementTooltip}
      marginTooltip={marginTooltip}
      style={{ padding: '4px 8px' }}
    >
      <FloatingInspectorCircleRenderer src={src} />
      {showText && <MainText>{t(text)}</MainText>}
    </FloatingInspectorButton>
  )
}

export default FloatingInspectorButtonImageInCircleAndText
